import { default as app } from "../app/vuex.js";

export default { ...app };
